<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">バンドルミックスマッチ設定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">プロモーションNO</label>
              <div class="list-input-content">
                <select style="width:197px" #cmb_PromotionNo [tabindex]="0" forcedEnabledMode="true" [autofocus]="true" id="cmb_PromotionNo"
                  [(ngModel)]="KYMW1308Model.promotionNo" (change)="eventNo_CHANGEHandler($event)">
                  <ng-template ngFor let-item [ngForOf]="KYMW1308Model.promotionNoList" let-i="index">
                    <option value="{{item}}">{{item}}</option>
                  </ng-template>
                </select>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title">プロモーション名称</label>
              <div class="list-input-content">
                <app-text-input #txt_PromotionName type="text" [tabindex]="0" id="txt_PromotionName"
                  [subid]="'txt_PromotionName'" [(ngModel)]="KYMW1308Model.promotionName" [restrict]="'[ -￮]'"
                  [maxChars]="20" [fullOnly]="true" [disabled]="KYMW1308Model.disabledPromotionName"
                  [displayCountField]="false" style="width:21rem;">
                </app-text-input>
              </div>
            </div>
            <button [tabindex]="0" id="btn_Search" class="btn-secondary" forcedEnabledMode="true"
              (click)="eventSearch_CLICKHandler($event)">バンドルミックスマッチ検索</button>
          </div>

          <div class="column-list">
            <label class="list-input-title">区分</label>
            <div class="list-input-content">
              <app-radio-label #rbt_Bundle name="grp_PromotionDiv" [tabindex]="0" value="B" id="rbt_Bundle"
                [subid]="'rbt_Bundle'" label="バンドル" [(ngModel)]="KYMW1308Model.promotionDiv"
                [disabled]="KYMW1308Model.disabledBundle" (change)="eventDiv_CHANGEHandler($event)"></app-radio-label>
              <app-radio-label #rbt_Mix name="grp_PromotionDiv" [tabindex]="0" value="P" id="rbt_Mix"
                [subid]="'rbt_Mix'" label="ミックスマッチ" [(ngModel)]="KYMW1308Model.promotionDiv"
                [disabled]="KYMW1308Model.disabledMix" (change)="eventDiv_CHANGEHandler($event)"></app-radio-label>
              <app-radio-label #rbt_Point name="grp_PromotionDiv" [tabindex]="0" value="T" id="rbt_Point"
                [subid]="'rbt_Point'" label="わくわくポイント" [(ngModel)]="KYMW1308Model.promotionDiv"
                [disabled]="KYMW1308Model.disabledPoint" (change)="eventDiv_CHANGEHandler($event)"></app-radio-label>
              <div class="block-row caution-color">
                <label>注意事項: １商品で複数のバンドルミックスマッチ設定はできません。</label>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h2>設定値一括反映</h2>
          <div class="element-column">
            <div class="column-list">
              <label class="list-input-title">設定単位</label>
              <div class="list-input-content">
                <app-radio-label #rbt_UnitAll name="grp_SetUnit" [tabindex]="0" value="1" id="rbt_UnitAll"
                  [subid]="'rbt_UnitAll'" label="全生協" [(ngModel)]="KYMW1308Model.setUnit"
                  [disabled]="KYMW1308Model.disabledUnitAll" (change)="eventUnit_CHANGEHandler($event)"></app-radio-label>
                <app-radio-label #rbt_UnitCoop name="grp_SetUnit" [tabindex]="0" value="2" id="rbt_UnitCoop"
                  [subid]="'rbt_UnitCoop'" label="生協単位" [(ngModel)]="KYMW1308Model.setUnit"
                  [disabled]="KYMW1308Model.disabledUnitCoop"
                  (change)="eventUnit_CHANGEHandler($event)"></app-radio-label>
              </div>
              
              <label class="list-input-title">生協選択</label>
              <div class="list-input-content">
                <app-checkbox-label #chk_CoopIB id="chk_CoopIB" [subid]="'chk_CoopIB'" label="い" [tabindex]="0"
                  [(ngModel)]="KYMW1308Model.coopIB" [disabled]="KYMW1308Model.disabledCoopIB">
                </app-checkbox-label>
                <app-checkbox-label #chk_CoopTO id="chk_CoopTO" [subid]="'chk_CoopTO'" label="と" [tabindex]="0"
                  [(ngModel)]="KYMW1308Model.coopTO" [disabled]="KYMW1308Model.disabledCoopTO">
                </app-checkbox-label>
                <app-checkbox-label #chk_CoopGU id="chk_CoopGU" [subid]="'chk_CoopGU'" label="ぐ" [tabindex]="0"
                  [(ngModel)]="KYMW1308Model.coopGU" [disabled]="KYMW1308Model.disabledCoopGU">
                </app-checkbox-label>
                <app-checkbox-label #chk_CoopTI id="chk_CoopTI" [subid]="'chk_CoopTI'" label="ち" [tabindex]="0"
                  [(ngModel)]="KYMW1308Model.coopTI" [disabled]="KYMW1308Model.disabledCoopTI">
                </app-checkbox-label>
                <app-checkbox-label #chk_CoopSA id="chk_CoopSA" [subid]="'chk_CoopSA'" label="さ" [tabindex]="0"
                  [(ngModel)]="KYMW1308Model.coopSA" [disabled]="KYMW1308Model.disabledCoopSA">
                </app-checkbox-label>
                <app-checkbox-label #chk_CoopTK id="chk_CoopTK" [subid]="'chk_CoopTK'" label="とう" [tabindex]="0"
                  [(ngModel)]="KYMW1308Model.coopTK" [disabled]="KYMW1308Model.disabledCoopTK">
                </app-checkbox-label>
                <app-checkbox-label #chk_CoopNA id="chk_CoopNA" [subid]="'chk_CoopNA'" label="な" [tabindex]="0"
                  [(ngModel)]="KYMW1308Model.coopNA" [disabled]="KYMW1308Model.disabledCoopNA">
                </app-checkbox-label>
                <app-checkbox-label #chk_CoopNI id="chk_CoopNI" [subid]="'chk_CoopNI'" label="に" [tabindex]="0"
                  [(ngModel)]="KYMW1308Model.coopNI" [disabled]="KYMW1308Model.disabledCoopNI">
                </app-checkbox-label>
                <app-checkbox-label #chk_CoopKU id="chk_CoopKU" [subid]="'chk_CoopKU'" label="ク" [tabindex]="0"
                  [(ngModel)]="KYMW1308Model.coopKU" [disabled]="KYMW1308Model.disabledCoopKU">
                </app-checkbox-label>
              </div>
            </div>

            <div class="block-row">
              <div class="column-list">
                <label class="list-input-title">成立数量</label>
                <div class="list-input-content">
                  <input type="text" id="txt_ApprovedNum" #txt_ApprovedNum
                    [(ngModel)]="KYMW1308Model.approvedNum" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3"
                    [disabled]="KYMW1308Model.disabledApprovedNum" [tabindex]="0" style="width:3rem;"/>
                </div>
              </div>

              <div class="column-list">
                <label class="list-input-title">成立価格</label>
                <div class="list-input-content">
                  <input type="text" id="txt_ApprovedPrice" #txt_ApprovedPrice
                    [(ngModel)]="KYMW1308Model.approvedPrice" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6"
                    [disabled]="KYMW1308Model.disabledApprovedPrice" [tabindex]="0" style="width:6rem;"/>
                </div>
              </div>

              <div class="column-list">
                <label class="list-input-title">わくわくポイント</label>
                <div class="list-input-content">
                  <input type="text" id="txt_WakuwakuPoint" #txt_WakuwakuPoint
                    [(ngModel)]="KYMW1308Model.wakuwakuPoint" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3"
                    [disabled]="KYMW1308Model.disabledWakuwakuPoint" [tabindex]="0" style="width:3rem;"/>
                </div>
              </div>

              <div class="column-list">
                <label class="list-input-title">値引率</label>
                <div class="list-input-content">
                  <input type="text" id="txt_DiscountPercent" #txt_DiscountPercent
                    [(ngModel)]="KYMW1308Model.discountPercent" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="2"
                    [disabled]="KYMW1308Model.disabledDiscountPercent" [tabindex]="0" style="width:2rem;"/>
                  <label>％</label>
                </div>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">対象</label>
              <div class="list-input-content">
                <app-radio-label id="rbt_TargetAll" #rbt_TargetAll [subid]="'rbt_TargetAll'"
                  [(ngModel)]="KYMW1308Model.reflectionTarget" name="grp_ReflectionTarget" value="1" label="全商品"
                  [disabled]="KYMW1308Model.disabledTargetAll" [tabindex]="0"></app-radio-label>
                <app-radio-label id="rbt_TargetGoods" #rbt_TargetGoods [subid]="'rbt_TargetGoods'"
                  [(ngModel)]="KYMW1308Model.reflectionTarget" name="grp_ReflectionTarget" value="2" label="選択商品"
                  [disabled]="KYMW1308Model.disabledTargetGoods" [tabindex]="0"></app-radio-label>
              </div>
            </div>

            <button id="btn_Reflection" class="btn-secondary" #btn_Reflection
              [disabled]="KYMW1308Model.disabledReflection" (click)="eventReflection_CLICKHandler($event)"
              [tabindex]="0">一括反映
            </button>
          </div>
        </div>  

        <div>
          <div class="layout_balance">
            <h2>プロモーション情報</h2>
            <div>
              <button id="btn_DelRow" class="btn-tartiary warning" [disabled]="KYMW1308Model.disabledDelRow"
                (click)="eventDelRow_CLICKHandler($event)" [tabindex]="0">行削除</button>
              <button id="btn_DelAll" class="btn-tartiary warning" [disabled]="KYMW1308Model.disabledDelAll"
                (click)="eventDelAll_CLICKHandler($event)" [tabindex]="0">全削除</button>
            </div>
          </div>

          <wj-flex-grid #dtg_PromotionInfo editable="false" [headersVisibility]="'Column'" [frozenColumns]="3"
            id="dtg_PromotionInfo" [allowDragging]="'None'" [tabindex]="-1" [itemsSource]="KYMW1308Model.promotionInfo"
            (pasting)="onPasting($event)">
            <wj-flex-grid-column [minWidth]="5" editable="false" [header]="'Ｐコード'" id="col_PCode" [binding]="'pCode'"
              [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" editable="false" [header]="'商品名'" id="col_GuideGoodsName"
              [binding]="'guideGoodsName'" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" editable="false" [header]="'規格名'" id="col_GuideStandardName"
              [binding]="'guideStandardName'" [isReadOnly]="true"></wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_SupplyPiceIB" [binding]="'thisTimeSupplyPriceIB'"
              [header]="'供給価格\n\nいばらき'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceIB">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeCostPriceIB" [binding]="'thisTimeCostPriceIB'"
              [header]="'仕入価格\n\nいばらき'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceIB">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedNumIB" [binding]="'approvedNumIB'"
              [header]="'成立数量\n\nいばらき'" [multiLine]="true" [isReadOnly]="false" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumIB">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" #txt_approvedNumIB
                  plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 5)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgIB === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedPriceIB" [binding]="'approvedPriceIB'"
              [header]="'成立価格\n\nいばらき'" [multiLine]="true" [isReadOnly]="false" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedPriceIB">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" #txt_approvedPriceIB
                  [(ngModel)]="cell.value" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 6)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgIB === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_WakuwakuPointIB" [binding]="'wakuwakuPointIB'"
              [header]="'わくわく\nポイント\nいばらき'" [multiLine]="true" [isReadOnly]="false" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.wakuwakuPointIB">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 7)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgIB === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeSupplyPriceTO" [binding]="'thisTimeSupplyPriceTO'"
              [header]="'供給価格\n\nとちぎ'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTO">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeCostPriceTO" [binding]="'thisTimeCostPriceTO'"
              [header]="'仕入価格\n\nとちぎ'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTO">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedNumTO" [binding]="'approvedNumTO'"
              [header]="'成立数量\n\nとちぎ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumTO">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 10)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgTO === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedPriceTO" [binding]="'approvedPriceTO'"
              [header]="'成立価格\n\nとちぎ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedPriceTO">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" #txt_approvedPriceTO
                  [(ngModel)]="cell.value" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 11)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgTO === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_WakuwakuPointTO" [binding]="'wakuwakuPointTO'"
              [header]="'わくわく\nポイント\nとちぎ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.wakuwakuPointTO">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 12)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgTO === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeSupplyPriceGU" [binding]="'thisTimeSupplyPriceGU'"
              [header]="'供給価格\n\nぐんま'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceGU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeCostPriceGU" [binding]="'thisTimeCostPriceGU'"
              [header]="'仕入価格\n\nぐんま'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceGU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedNumGU" [binding]="'approvedNumGU'"
              [header]="'成立数量\n\nぐんま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumGU">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 15)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgGU === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedPriceGU" [binding]="'approvedPriceGU'"
              [header]="'成立価格\n\nぐんま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedPriceGU">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" #txt_approvedPriceGU
                  [(ngModel)]="cell.value" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 16)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgGU === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_WakuwakuPointGU" [binding]="'wakuwakuPointGU'"
              [header]="'わくわく\nポイント\nぐんま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.wakuwakuPointGU">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 17)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgGU === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeSupplyPriceTI" [binding]="'thisTimeSupplyPriceTI'"
              [header]="'供給価格\n\nちば'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeCostPriceTI" [binding]="'thisTimeCostPriceTI'"
              [header]="'仕入価格\n\nちば'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedNumTI" [binding]="'approvedNumTI'"
              [header]="'成立数量\n\nちば'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumTI">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 20)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgTI === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedPriceTI" [binding]="'approvedPriceTI'"
              [header]="'成立価格\n\nちば'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedPriceTI">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" #txt_approvedPriceTI
                  [(ngModel)]="cell.value" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 21)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgTI === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_WakuwakuPointTI" [binding]="'wakuwakuPointTI'"
              [header]="'わくわく\nポイント\nちば'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.wakuwakuPointTI">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 22)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgTI === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeSupplyPriceSA" [binding]="'thisTimeSupplyPriceSA'"
              [header]="'供給価格\n\nさいたま'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceSA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeCostPriceSA" [binding]="'thisTimeCostPriceSA'"
              [header]="'仕入価格\n\nさいたま'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceSA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedNumSA" [binding]="'approvedNumSA'"
              [header]="'成立数量\n\nさいたま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumSA">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 25)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgSA === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedPriceSA" [binding]="'approvedPriceSA'"
              [header]="'成立価格\n\nさいたま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedPriceSA">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" #txt_approvedPriceSA
                  [(ngModel)]="cell.value" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 26)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgSA === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_WakuwakuPointSA" [binding]="'wakuwakuPointSA'"
              [header]="'わくわく\nポイント\nさいたま'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.wakuwakuPointSA">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 27)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgSA === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeSupplyPriceTK" [binding]="'thisTimeSupplyPriceTK'"
              [header]="'供給価格\n\nとうきょう'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceTK">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeCostPriceTK" [binding]="'thisTimeCostPriceTK'"
              [header]="'仕入価格\n\nとうきょう'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceTK">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedNumTK" [binding]="'approvedNumTK'"
              [header]="'成立数量\n\nとうきょう'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumTK">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 30)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgTK === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedPriceTK" [binding]="'approvedPriceTK'"
              [header]="'成立価格\n\nとうきょう'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedPriceTK">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" #txt_approvedPriceTK
                  [(ngModel)]="cell.value" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 31)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgTK === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_WakuwakuPointTK" [binding]="'wakuwakuPointTK'"
              [header]="'わくわく\nポイント\nとうきょう'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.wakuwakuPointTK">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 32)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgTK === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeSupplyPriceNA" [binding]="'thisTimeSupplyPriceNA'"
              [header]="'供給価格\n\nながの'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceNA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeCostPriceNA" [binding]="'thisTimeCostPriceNA'"
              [header]="'仕入価格\n\nながの'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceNA">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedNumNA" [binding]="'approvedNumNA'"
              [header]="'成立数量\n\nながの'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumNA">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 35)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgNA === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedPriceNA" [binding]="'approvedPriceNA'"
              [header]="'成立価格\n\nながの'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedPriceNA">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" #txt_approvedPriceNA
                  [(ngModel)]="cell.value" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 36)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgNA === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_WakuwakuPointNA" [binding]="'wakuwakuPointNA'"
              [header]="'わくわく\nポイント\nながの'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.wakuwakuPointNA">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 37)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgNA === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeSupplyPriceNI" [binding]="'thisTimeSupplyPriceNI'"
              [header]="'供給価格\n\nにいがた'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceNI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeCostPriceNI" [binding]="'thisTimeCostPriceNI'"
              [header]="'仕入価格\n\nにいがた'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceNI">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedNumNI" [binding]="'approvedNumNI'"
              [header]="'成立数量\n\nにいがた'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumNI">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 40)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgNI === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedPriceNI" [binding]="'approvedPriceNI'"
              [header]="'成立価格\n\nにいがた'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedPriceNI">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" #txt_approvedPriceNI
                  [(ngModel)]="cell.value" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 41)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgNI === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_WakuwakuPointNI" [binding]="'wakuwakuPointNI'"
              [header]="'わくわく\nポイント\nにいがた'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.wakuwakuPointNI">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 42)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgNI === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeSupplyPriceKU" [binding]="'thisTimeSupplyPriceKU'"
              [header]="'供給価格\n\nクルコ'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeSupplyPriceKU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_thisTimeCostPriceKU" [binding]="'thisTimeCostPriceKU'"
              [header]="'仕入価格\n\nクルコ'" [multiLine]="true" [isReadOnly]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <app-comma-format [textAlign]="'right'" [Data]="cell.item.thisTimeCostPriceKU">
                </app-comma-format>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedNumKU" [binding]="'approvedNumKU'"
              [header]="'成立数量\n\nクルコ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedNumKU">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 45)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgKU === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_ApprovedPriceKU" [binding]="'approvedPriceKU'"
              [header]="'成立価格\n\nクルコ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.approvedPriceKU">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" #txt_approvedPriceKU
                  [(ngModel)]="cell.value" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 46)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgKU === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" id="col_WakuwakuPointKU" [binding]="'wakuwakuPointKU'"
              [header]="'わくわく\nポイント\nクルコ'" [multiLine]="true" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                <app-comma-format [textAlign]="'right'" [Data]="item.wakuwakuPointKU">
                </app-comma-format>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
                <input type="text" [style.width.%]="'100'" [style.text-align]="'right'" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="3" [(ngModel)]="cell.value" autocomplete="off"
                  (keydown)="eventGridKeyDownHandler($event, dtg_PromotionInfo, 47)"
                  [disabled]="!KYMW1308Model.editLock || (cell.item.handlingFlgKU === '1' ? false : true)"
                  [tabindex]="0" />
              </ng-template>
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button [tabindex]="0" id="btn_Regist" class="btn-primary" (click)="eventRegist_CLICKHandler($event)"
            [disabled]="KYMW1308Model.disabledRegist">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler($event)"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>